import { useTranslation } from "react-i18next"
import type { TFunction } from "react-i18next"
import { Icon, Layout, Link } from "@oysterhr/ui"
import classNames from "classnames"
import { CalculationForm } from "../CalculationForm"
import { CalculationsMainSection } from "../CalculationsMainSection"
import { useCalculationsProvider } from "../../contexts"
import { ReactNode } from "react"

export const Header = ({
  backButton,
  t,
  isEditMode,
  showAddNewHireLabel,
  showSubtitle,
}: {
  backButton: ReactNode
  t: TFunction
  isEditMode: boolean
  showAddNewHireLabel: boolean
  showSubtitle?: boolean
}) => (
  <Layout.Header
    beforeHeader={backButton}
    align="center"
    title={isEditMode ? t("editHire") : showAddNewHireLabel ? t("addNewHire") : t("pageTitle")}
    subtitle={showSubtitle ? t("pageSubtitle") : undefined}
  />
)

export const CostCalculatorWrapper = () => {
  const { t } = useTranslation("components/Quote")
  const {
    calculations,
    isCalculationFormOpen,
    setIsCalculationFormOpen,
    isEditMode,
    setIsEditMode,
  } = useCalculationsProvider()

  const handleBack = () => {
    setIsEditMode(false)
    setIsCalculationFormOpen(false)
  }

  const isFirstCalculation = calculations.length === 0
  const showAddNewHireLabel = isCalculationFormOpen && !isEditMode && !isFirstCalculation

  return (
    <div className="relative w-full">
      <Header
        backButton={
          calculations.length === 0 || !isCalculationFormOpen ? null : (
            <Link
              as="button"
              startAdornment={<Icon name="ArrowLeft" size="sm" />}
              onClick={handleBack}
            >
              {t("back")}
            </Link>
          )
        }
        t={t}
        showAddNewHireLabel={showAddNewHireLabel}
        isEditMode={isEditMode}
        showSubtitle={!showAddNewHireLabel}
      />
      <div
        className={classNames("", {
          hidden: !isCalculationFormOpen && calculations.length > 0,
          flex: isCalculationFormOpen || calculations.length === 0,
        })}
      >
        <CalculationForm toggleForm={setIsCalculationFormOpen} />
      </div>

      <div
        className={classNames("", {
          hidden: calculations.length > 0 && isCalculationFormOpen,
        })}
      >
        <CalculationsMainSection />
      </div>
    </div>
  )
}
